import { IDType } from "./types";

export const allowedViews = [
  "highlights",
  "lineup",
  "table",
  "statistics",
  "matches",
  "squad",
  "totw",
  "teamstats",
  "playerstats",
] as const;
export type View = (typeof allowedViews)[number];

export const isYmd = (s?: string): s is string =>
  typeof s === "string" && /^\d{4}-\d{2}-\d{2}$/.test(s);

export const toYmd = (d: Date): string => {
  const y = d.getFullYear();
  const m = `${d.getMonth() + 1}`.padStart(2, "0");
  const day = `${d.getDate()}`.padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const pathHome = () => `/home`;
export const pathHomeDate = (dateYmd: string) => `/home/date/${dateYmd}`;

export const pathHomeLeagueDate = (leagueId: IDType, dateYmd: string) =>
  `/home/league/${leagueId}/date/${dateYmd}`;

export const pathHomeTournament = (tournamentId: IDType) =>
  `/home/tournament/${tournamentId}`;
export const pathHomeTournamentDate = (tournamentId: IDType, dateYmd: string) =>
  `/home/tournament/${tournamentId}/date/${dateYmd}`;

export const pathMatch = (matchId: IDType) => `/match/${matchId}`;
export const pathMatchView = (matchId: IDType, view: View) =>
  `/match/${matchId}/${view}`;

export const pathTeam = (teamId: IDType) => `/team/${teamId}`;
export const pathTeamView = (teamId: IDType, view: View) =>
  `/team/${teamId}/${view}`;

export const pathTeamManagement = () => `/team/management`;

export const pathLeague = (leagueId: IDType) => `/league/${leagueId}`;
export const pathLeagueView = (leagueId: IDType, view: View) =>
  `/league/${leagueId}/${view}`;

export const pathPlayerView = (playerId: IDType) => `/player/${playerId}`;

export const pathNews = () => `/news`;
